import { useAuth } from '../context/AuthContext';

export const useUserData = () => {
  const { user, dbUser, loading } = useAuth();
  return { userData: dbUser, loading, isAuthenticated: !!user };
};
